import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.33",
      d: "M3 13h1.345c.393 0 .59 0 .774-.044q.247-.06.464-.193c.162-.099.301-.238.579-.516h0l6.339-6.339a1.704 1.704 0 0 0-2.41-2.409L3.754 9.838h0c-.278.278-.417.417-.516.579q-.133.216-.193.464C3 11.066 3 11.262 3 11.655z"
    }, null, -1)
  ]))]))
}
export default { render: render }